import { useEffect } from "react";
import { Icon } from "@iconify/react";
import "../styles/Toast.css";

function Toast({ message, type = "success", onClose, duration = 3000 }) {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  const getIcon = () => {
    switch (type) {
      case "success":
        return "mdi:check-circle";
      case "error":
        return "mdi:alert-circle";
      case "info":
        return "mdi:information";
      default:
        return "mdi:check-circle";
    }
  };

  return (
    <div className={`toast toast-${type}`}>
      <Icon icon={getIcon()} className="toast-icon" />
      <span className="toast-message">{message}</span>
      <button className="toast-close" onClick={onClose}>
        <Icon icon="mdi:close" />
      </button>
    </div>
  );
}

export default Toast;
